import { useEffect, useState } from 'react'

/**
 * Time-based progress 0 → 85 over 2 minutes (ease-out so it slows near the end).
 * Reusable across status page and preview loading states.
 */
export function useSimulatingProgress(
  isActive: boolean,
  startTimeMs: number | null,
): number {
  const [percent, setPercent] = useState(0)
  const DURATION_MS = 120_000
  const MAX_PERCENT = 85

  useEffect(() => {
    if (!isActive || startTimeMs == null) {
      setPercent(0)
      return
    }
    const tick = () => {
      const elapsed = Date.now() - startTimeMs
      if (elapsed >= DURATION_MS) {
        setPercent(MAX_PERCENT)
        return
      }
      const t = elapsed / DURATION_MS
      const eased = 1 - (1 - t) ** 1.5
      setPercent(Math.round(eased * MAX_PERCENT))
    }
    tick()
    const id = setInterval(tick, 400)
    return () => clearInterval(id)
  }, [isActive, startTimeMs])

  return percent
}
